import React from 'react';
import { Alert, MenuItem, Stack, TextField } from '@mui/material';

export default function NextFrameModuleSelector({ modules, onChange, error }: {
  modules?: number[]; onChange: (modules: number[]) => void; error?: string;
}) {
  return <Stack spacing={1.5}>
    <TextField select fullWidth required label="Modulo acquistato" value={Math.max(0, ...(modules || [])) || ''}
      error={!!error} helperText={error || 'Ogni modulo include quelli precedenti. Aggiornamenti e assistenza sono coperture separate.'}
      onChange={e => onChange(Array.from({ length: Number(e.target.value) }, (_, i) => i + 1))}>
      <MenuItem value={1}>1 · Parametrico e import CAD del pezzo singolo</MenuItem>
      <MenuItem value={2}>2 · Modulo 1 + CAD completo e incastri (senza assiemi importati)</MenuItem>
      <MenuItem value={3}>3 · Moduli 1–2 + assiemi importati</MenuItem>
      {Array.from({ length: 7 }, (_, i) => <MenuItem key={i + 4} value={i + 4} disabled>{i + 4} · Riservato a sviluppi futuri</MenuItem>)}
    </TextField>
    <Alert severity="info">Le modifiche si applicano al rinnovo del certificato. Un PC offline conserva i diritti già firmati fino alla scadenza del certificato. Le versioni precedenti al sistema modulare devono essere aggiornate.</Alert>
  </Stack>;
}
